import { useEffect, useState } from 'react';
import { Link, useNavigate, useRouter, useSearch } from '@tanstack/react-router';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Logo } from '@src/components/icons';
import { useAuthentication } from '@src/context/hooks';
import { EmailField, Form, PasswordField, Submit } from '@src/corelib/forms/generic';
// import { useTimeout } from '@src/corelib/hooks';
import Stack from '@mui/material/Stack';

import { createSchema } from '@src/corelib/validation';


const schema = createSchema({
  email: { type: 'email', label: 'Email' },
  password: { type: 'password', label: 'Password' },
});
const DEFAULT_VALUES = { email: '', password: '' };

function Login() {
  const auth = useAuthentication();

  const router = useRouter();
  const navigate = useNavigate();
  const { redirect = '/dashboard', loginAs } = useSearch({ strict: false });
  const [ isLoginAsPending, setIsLoginAsPending] = useState(loginAs);

  useEffect(() => {
    if (loginAs) {
      auth.refreshToken(loginAs).then(() => {
        router.invalidate().finally(() => {
          navigate({ to: decodeURIComponent(redirect) });
        });
      }).catch((error) => {
        setIsLoginAsPending(false);
      });
    }
  }, [loginAs]);

  // const timeout = useTimeout();

  const login = (values) => {
    return new Promise((resolve, reject) => {
      // TODO: why we need timeout here?
      // timeout.set(
      //   'login',
      // () => {
      auth.login(values.email, values.password).then(() => {
        router.invalidate().finally(() => {
          navigate({ to: decodeURIComponent(redirect) });
          resolve();
        });
      }).catch((error) => {
        reject(error);
      });
      // };
      //   500,
      // );

    });
  };

  return (
    <Box sx={StyleSheet.root}>
      <Stack sx={StyleSheet.content}>
        <Box sx={StyleSheet.logo}>
          <Logo />
        </Box>

        <Typography variant="h3" align="center" component="h1">
          Login
        </Typography>

        {!isLoginAsPending && (
          <Form
            schema={schema}
            sx={{width: '100%'}}
            defaultValues={DEFAULT_VALUES}
            onSubmit={login}
          >
            <EmailField required fullWidth name="email" label="Email" />
            <PasswordField required fullWidth name="password" label="Password" />

            <Box sx={StyleSheet.actions}>
              <Submit
                fullWidth
                variant="contained"
                color="primary"
                loadingPosition="start"
              >
                Login
              </Submit>

              <Box sx={StyleSheet.links}>
                <Link variant="body2" to="/login">
                  Forgot password?
                </Link>
              </Box>
            </Box>
          </Form>
        )}
      </Stack>
    </Box>
  );
}

const StyleSheet = {
  root: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    maxWidth: '360px',
    padding: '16px',
    alignItems: 'center',
    transform: 'translateY(-10vh)',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    width: '250px',
    marginBottom: '100px',
    '& svg': { width: '100%', height: '100%'},
  },
  actions: {
    mt: '16px',
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    '& a': (theme) => ({
      color: theme.palette.common.black,
      textDecoration: 'none',
    }),
    marginTop: '16px',
  },
};

Login.displayName = 'Login';
export default Login;
